import React from "react";
import UserAddComponent from "./UserAdd";

const UserAdd = () => {
    return <UserAddComponent />;
};

export default UserAdd;
